export default __webpack_public_path__ + "static/media/019-b.39a8ea20.jpg";